import React, { useState } from "react";
// import profile from "../../Assets/Images/undraw_profile.svg";
import { Modal } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEllipsis } from "@fortawesome/free-solid-svg-icons";

const CreateAdmin = ({ onHide, formValues, setFormValues, submitHandler }) => {
  const [error, setError] = useState({
    userName: "",
    role: "",
    emailId: "",
    password: "",
  });
  const [visible, setVisible] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError({ ...error, [name]: "" });
    setFormValues({ ...formValues, [name]: value });
  };

  const handleToggleShow = () => {
    setVisible((prev) => !prev);
  };

  const handleSubmit = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (formValues.userName === "") {
      setError({ ...error, userName: "Username required" });
    } else if (formValues.role === "") {
      setError({ ...error, role: "Role required" });
    } else if (formValues.emailId === "") {
      setError({ ...error, emailId: "Email required" });
    } else if (!emailRegex.test(formValues.emailId)) {
      setError({ ...error, emailId: "Enter a valid email" });
    } else if (formValues.password === "") {
      setError({ ...error, password: "Password required" });
    } else if (formValues.password.trim().length < 4) {
      setError({ ...error, password: "Enter minimum 4 characters" });
    } else {
      onHide();
      submitHandler();
    }
  };

  return (
    <>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group input-group mb-5">
              <label className="has-float-label">
                <input
                  className="form-control"
                  type="text"
                  // placeholder="Name"
                  value={formValues.userName}
                  name="userName"
                  onChange={handleChange}
                />
                <span>Name</span>
                {error.userName && (
                  <p className="form-error">{error.userName}</p>
                )}
              </label>
            </div>
            <div className="form-group input-group mb-5">
              <label className="has-float-label">
                <select
                  className="form-control"
                  value={formValues.role}
                  name="role"
                  onChange={handleChange}
                >
                  <option value="">Select Role</option>
                  <option value="A">Admin</option>
                  <option value="U">SupportAdmin</option>
                </select>
                <span>Role</span>
                {error.role && <p className="form-error">{error.role}</p>}
              </label>
            </div>
            <div className="form-group input-group mb-5">
              <label className="has-float-label">
                <input
                  className="form-control"
                  type="text"
                  value={formValues.emailId}
                  name="emailId"
                  onChange={handleChange}
                />
                <span>Email</span>
                {error.emailId && <p className="form-error">{error.emailId}</p>}
              </label>
            </div>

            <div className="form-group input-group">
              <label className="has-float-label">
                <div className="admin-eye">
                  <input
                    className="form-control"
                    type={visible ? "text" : "password"}
                    placeholder=""
                    value={formValues.password}
                    name="password"
                    onChange={handleChange}
                  />
                  <div className="input-group-append cursor-pointer">
                    <span
                      role="presentation"
                      onClick={handleToggleShow}
                      className="input-group-text sign-icon"
                    >
                      {!visible && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_23_60)">
                            <path
                              d="M6.89331 4.78272L8.8974 6.78681L8.90694 6.68184C8.90694 5.62888 8.05124 4.77318 6.99829 4.77318L6.89331 4.78272Z"
                              fill="#ABABAB"
                            />
                            <path
                              d="M6.99843 3.50074C8.75439 3.50074 10.1795 4.92588 10.1795 6.68184C10.1795 7.09221 10.0968 7.48348 9.95369 7.84293L11.8146 9.70388C12.7753 8.90224 13.5324 7.86521 14 6.68184C12.8962 3.88885 10.1827 1.9102 6.99846 1.9102C6.10774 1.9102 5.25523 2.06925 4.46313 2.35555L5.83737 3.72659C6.19679 3.58663 6.58807 3.50074 6.99843 3.50074Z"
                              fill="#ABABAB"
                            />
                            <path
                              d="M0.636209 1.7671L2.08679 3.21768L2.37628 3.50717C1.32652 4.3279 0.496251 5.41902 0 6.6819C1.10067 9.47489 3.81731 11.4535 6.99842 11.4535C7.98457 11.4535 8.92616 11.2627 9.78825 10.9159L10.0587 11.1863L11.9132 13.0441L12.7244 12.2361L1.44739 0.955925L0.636209 1.7671ZM4.15452 5.28222L5.13748 6.26518C5.10885 6.40198 5.08976 6.53875 5.08976 6.6819C5.08976 7.73485 5.94547 8.59055 6.99842 8.59055C7.14157 8.59055 7.27837 8.57147 7.41197 8.54284L8.39493 9.52579C7.97183 9.73575 7.50105 9.863 6.99842 9.863C5.24245 9.863 3.81731 8.43786 3.81731 6.6819C3.81731 6.17929 3.94457 5.70848 4.15452 5.28222Z"
                              fill="#ABABAB"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_23_60">
                              <rect width="14" height="14" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                      {visible && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                        >
                          <path
                            d="M15.4567 8.80458C15.3979 8.72029 13.9961 6.71925 12.0616 5.35146C11.0586 4.641 9.79353 4.25 8.50011 4.25C7.20741 4.25 5.94232 4.641 4.9372 5.35146C3.00274 6.71925 1.60236 8.72029 1.54357 8.80458C1.46116 8.92323 1.41699 9.06423 1.41699 9.20869C1.41699 9.35315 1.46116 9.49415 1.54357 9.61279C1.60236 9.69708 3.00274 11.6981 4.9372 13.0659C5.94232 13.7757 7.20741 14.1667 8.50011 14.1667C9.79353 14.1667 11.0586 13.7757 12.0616 13.0652C13.9961 11.6974 15.3979 9.69637 15.4567 9.61208C15.5393 9.49366 15.5836 9.35274 15.5836 9.20833C15.5836 9.06393 15.5393 8.923 15.4567 8.80458ZM8.50011 11.6875C7.1302 11.6875 6.02095 10.5754 6.02095 9.20833C6.02095 7.83842 7.1302 6.72917 8.50011 6.72917C9.8672 6.72917 10.9793 7.83842 10.9793 9.20833C10.9793 10.5754 9.8672 11.6875 8.50011 11.6875ZM9.91678 9.20833C9.91678 9.98892 9.2807 10.625 8.50011 10.625C8.21992 10.625 7.94603 10.5419 7.71306 10.3862C7.48009 10.2306 7.29851 10.0093 7.19129 9.75047C7.08406 9.49161 7.05601 9.20676 7.11067 8.93196C7.16533 8.65715 7.30026 8.40472 7.49838 8.2066C7.6965 8.00847 7.94893 7.87355 8.22374 7.81889C8.49854 7.76423 8.78339 7.79228 9.04225 7.8995C9.30111 8.00673 9.52236 8.18831 9.67803 8.42128C9.8337 8.65425 9.91678 8.92814 9.91678 9.20833Z"
                            fill="#ABABAB"
                          />
                        </svg>
                      )}
                    </span>
                  </div>
                </div>
                <span>Password</span>
                {error.password && (
                  <p className="form-error">{error.password}</p>
                )}
              </label>
            </div>
          </div>

          <div className="col-md-1"></div>

          {/* <div className="col-md-5">
            <div className="admin-card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12 text-right">
                    <Dropdown className="drop-left">
                      <Dropdown.Toggle className="ml-auto btn nav-link block-dropdown dropdown-toggle no-arrow">
                        <FontAwesomeIcon
                          icon={faEllipsis}
                          className="mt-2 ml-3"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <button className="dropdown-item" type="button">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                          >
                            <rect width="17" height="17" fill="white" />
                            <path
                              d="M8.49999 1.41669C4.58999 1.41669 1.41666 4.59002 1.41666 8.50002C1.41666 12.41 4.58999 15.5834 8.49999 15.5834C12.41 15.5834 15.5833 12.41 15.5833 8.50002C15.5833 4.59002 12.41 1.41669 8.49999 1.41669ZM2.83332 8.50002C2.83332 5.36919 5.36916 2.83335 8.49999 2.83335C9.81041 2.83335 11.0146 3.2796 11.9708 4.03044L4.03041 11.9709C3.25249 10.9814 2.83077 9.75865 2.83332 8.50002ZM8.49999 14.1667C7.18957 14.1667 5.98541 13.7204 5.02916 12.9696L12.9696 5.02919C13.7475 6.01863 14.1692 7.24139 14.1667 8.50002C14.1667 11.6309 11.6308 14.1667 8.49999 14.1667Z"
                              fill="#666666"
                            />
                          </svg>{" "}
                          Block
                        </button>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3"></div>
                  <div className="col-md-4">
                    <img
                      className="img-profile rounded-circle admin-img ml-5"
                      src={profile}
                      alt="profile"
                    />
                  </div>
                  <div className="col-md-4"></div>
                </div>
                <p className="head text-center ml-4 mt-3">Profile</p>
              </div>
            </div>
          </div> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer className="mt-4 justify-content-center">
          <button
            type="button"
            className="btn btn-outline-primary modal-btn"
            onClick={handleSubmit}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary modal-btn"
            onClick={onHide}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal.Footer>
    </>
  );
};

export default CreateAdmin;
